import type { TContactFormValues } from 'src/components/contacts/Form';
import { defaultContactFormValues } from 'src/components/contacts/Form/types';
import { ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';
import { CONTACT_PHONE_RULES } from '../constants/contactRegistration';
import { getCountryCodeFromPhone as getCountryCodeFromDigits } from 'src/modules/phones/utils/getCountryCodeFromPhone';
import { normalizePhoneNumber } from 'src/modules/phones/utils/normalizePhoneNumber';

type BuildConversationContactValuesParams = {
    name?: string;
    phone?: string;
    storeId?: string;
};

const digitsOnly = (value?: string): string =>
    normalizePhoneNumber(value).replace(/\D/g, '');

const getCountryCodeFromPhone = (phone: string): ECountryCode =>
    getCountryCodeFromDigits(phone);

const removeCountryPrefix = (phone: string): string => {
    const rule = CONTACT_PHONE_RULES.find(({ prefix }) =>
        phone.startsWith(prefix)
    );

    return rule ? phone.slice(rule.prefix.length) : phone;
};

export const buildConversationContactInitialValues = ({
    name,
    phone,
    storeId,
}: BuildConversationContactValuesParams): Partial<TContactFormValues> => {
    const cleanPhone = digitsOnly(phone);

    return {
        ...defaultContactFormValues,
        name: name || defaultContactFormValues.name,
        phone: removeCountryPrefix(cleanPhone),
        countryCode: cleanPhone
            ? getCountryCodeFromPhone(cleanPhone)
            : defaultContactFormValues.countryCode,
        store: storeId || defaultContactFormValues.store,
    };
};
